import React, { useEffect, useState } from 'react';
import { Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextareaAutosize, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';
import PageNames from '../../../common/utils/pageNames';

export default function TooltipModal({  tooltip, onTriggerCreate, onTriggerUpdate }) {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [pageNames, setPageNames] = useState('');
  
  const [formData, setFormData] = useState({
      id: '',
      page: '',
      page_name: '',
      description: '',
      enabled: false
  });

  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create Tooltip');    
    setFormData({ ...formData, id: '', page: '', page_name: '', description: '', active: '' });
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update Tooltip');
  }

  const handleUpdate = async (event) => {
      const result = await createTooltip(event);
      
      if (result === 'success') {
        setOpen(false);
        if ( title === 'Create Tooltip' ) {
          onTriggerCreate(formData);
        } else {
          onTriggerUpdate(formData);
        }      
      }
  }

  const handleClose = async () => {
    setOpen(false);
    if (formData.id === '') {    
      await setFormData({ ...formData, id: '', page: '', description: '', active: '' });
    }
  }
  
  const handleInputChange = (field) => (e) => {      

      const value = e.target.value;
      
      if (field === 'page') {
        const name = pageNames.find(page => page.value === value); 
        setFormData({ ...formData, [field]: value, page_name: name.label });
      } else {
        setFormData({ ...formData, [field]: value });
      }
  }

  const createTooltip = async (event) => {
    event.preventDefault();
    let result = null;

    try {
        
        if (formData.id === '') {
          const response = await fetch(`${process.env.REACT_APP_API}/tooltips/create`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
        } else {
            const response = await fetch(`${process.env.REACT_APP_API}/tooltips/update`, {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            result = await response.json();
            if (result.message === 'success') {
              await handleClose();
            } else {
              toast.error(result.message);
            }
          }
          return result.message;
    } catch (error) {
      toast.error('Network error.  Please try again: ', error);
      return false;
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    setPageNames(PageNames);
    if (tooltip.id !== undefined) {
      setFormData(tooltip);
    }     
    setLoading(false);
  }, [tooltip]);

  if (!loading) {
    return (
      <>
          { formData.id === "" && 
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
              Add New
            </Button>
          }
          
          { formData.id !== '' && 
            <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
                <EditIcon />
            </Button>
          }
          
          <Modal 
            open={open} 
            onClose={handleClose}
            style={{
              overlay: {
                backgroundColor: '#080030', // Semi-transparent black
              },
              content: {
                backgroundColor: '#080030',
              },
            }}
          >
              <Box sx={{color: 'white', p: 4 }}>
                  <Box
                    component={Paper}
                    elevation={3}
                    sx={{
                      
                      mx: 'auto',
                      width: 800,
                      bgcolor: '#1e1e1e',
                      p: 2,
                    }}
                  >
                    <Typography variant="h4" component="h2" color="white" mb={2}>
                      {title}
                    </Typography>

                    <Box component="form" onSubmit={handleUpdate}>
                      <Stack spacing={2}>
                        <TextField
                          select
                          required
                          fullWidth                          
                          label="Page"
                          value={formData.page}
                          onChange={handleInputChange('page')}
                          sx={ textFieldStyles }
                        >
                          {pageNames.map((page) => (
                            <MenuItem key={page.value} value={page.value}>
                              {page.label}
                            </MenuItem>
                          ))}
                        </TextField>
                        <TextField
                          required
                          fullWidth
                          multiline
                          label="Description"
                          rows={5}
                          value={formData.description}
                          onChange={handleInputChange('description')}
                          sx={ textFieldStyles }
                        />
                        <TextField
                          select
                          required
                          fullWidth
                          label="Active"
                          value={formData.active}
                          onChange={handleInputChange('active')}
                          sx={ textFieldStyles }
                          >
                          {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </TextField>    
                      
                    
                    <ButtonGroup 
                      size="small"
                      variant="contained" 
                      aria-label="Basic button group" 
                      fullWidth
                      sx={{ mt:2 }}
                    >
                      <Button
                        onClick={handleClose}
                        type="cancel"
                        variant="contained"
                        sx={ Styles.buttonStyle }
                      >
                        Cancel
                      </Button>              
                      <Button
                        type="submit"                      
                        variant="contained"
                        sx={{ ...Styles.buttonStyle,  ml:4 }}
                      >
                        {title}
                      </Button>
                    </ButtonGroup>
                  </Stack>
                </Box>
              </Box>
            </Box>          
          </Modal>
      </>
    )
  }
}